<template>
  <div class="container multi-card-container">
    <div class="col-lg-12 card-col">
      <div class="card-ct card-rounded-shadowed">
        <div class="float-right" v-if="id">
          <button class="btn btn-danger" @click="$refs['modal-confirm'].show()">{{ $dt('btn.delete') }}</button>
        </div>
        <h2 v-if="id">{{ $dt('admin.achievement.edit.title', 'Sasnieguma informācija') }}</h2>
        <h2 v-else>{{ $dt('admin.achievement.create.title', 'Jauns sasniegums') }}</h2>
        <div v-if="spinners.contentIsLoading" class="col-12 text-center pb-4">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-form @submit="saveAchievement" class="mt-2">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-sm-3">
                    <b-form-group :label="$dt('active', 'Aktīvs')" label-for="is-active">
                      <b-form-checkbox v-model="achievement.isActive" id="is-active" switch />
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group :label="$dt('achievement_charity', 'Labdarība', 'admin')" label-for="is-charity">
                      <b-form-checkbox v-model="achievement.isCharity" id="is-charity" switch />
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group :label="$dt('achievement_highlighted', 'Izcelts', 'admin')" label-for="is-highlighted">
                      <b-form-checkbox v-model="achievement.isHighlighted" id="is-highlighted" switch />
                    </b-form-group>
                  </div>
                </div>
                <b-form-group :label="$dt('achievement_name', 'Nosaukums', 'admin')" label-for="name">
                  <b-form-input v-model="achievement.name" id="name" type="text" required />
                  <b-form-invalid-feedback v-if="errors['name']" :state="false">
                    {{ errors['name'][0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                
                <b-form-group :label="$dt('achievement_goal', 'Mērķis', 'admin')" label-for="goal">
                  <b-form-input v-model="achievement.goal" id="goal" type="number" min="1" required />
                  <b-form-invalid-feedback v-if="errors['goal']" :state="false">
                    {{ errors['goal'][0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                
                <b-form-group :label="$dt('achievement_color', 'Krāsa', 'admin')" label-for="color">
                  <b-form-input v-model="achievement.colorHex" id="color" type="color" required />
                  <b-form-invalid-feedback v-if="errors['color']" :state="false">
                    {{ errors['color'][0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
                
              </div>
              <div class="col-lg-6">
                <b-form-group :label="$dt('achievement_image', 'Attēls', 'admin')" label-for="image">
                  <b-form-file v-model="achievement.image" id="image" type="file" accept="image/*" @input="onImageChange" />
                  <b-form-invalid-feedback v-if="errors['image']" :state="false">
                    {{ errors['image'][0] }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="errors['image_id']" :state="false">
                    {{ errors['image_id'][0] }}
                  </b-form-invalid-feedback>
                  <b-img :src="achievement.imagePath" fluid class="mt-2 rounded-lg"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <TextsInput v-model="achievement.texts" :fields="textsFields" :errors="textsErrors" />
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <!-- cancel goes back -->
              <b-button variant="light" :to="{ name: 'Admin', params: { tab: 'achievements' } }">{{ $dt('btn.back', 'Atpakaļ') }}</b-button>
              <b-button type="submit" variant="success" class="ml-2">
                <b-spinner v-if="spinners.submitting" variant="light"/>
                <span v-else>{{ $dt('btn.save', 'Saglabāt') }}</span>
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>

    <b-modal
      :title="`${$dt('achievement_confirm_delete', 'Vai tiešām vēlaties dzēst sasniegumu', 'admin')} ${achievement.name}?`"
      ref="modal-confirm">
      <template v-slot:default>
        <p></p>
      </template>
      <template v-slot:modal-footer>
        <button type="button" class="btn btn-light px-4 py-2" @click="closeConfirmModal()">{{ $t('modal_close') }}</button>
        <button type="button" class="btn btn-danger px-4 py-2" @click="submitConfirmModal()">
          <b-spinner v-if="spinners.submitting" variant="light"/>
          <span v-else>{{ $t('delete') }}</span>
        </button>
      </template>
    </b-modal>
    <div v-if="id" class="col-lg-12 card-col">
      <div class="card-ct card-rounded-shadowed">
        <h2>{{ $dt('discount_codes_title', 'Kuponi') }}</h2>
        <DiscountCodeList :achievement_id="Number(id)" />
      </div>
    </div>
  </div>
</template>

<script>
import TextsInput from '@/components/Texts/TextsInputComponent';
import DiscountCodeList from '@/components/Admin/DiscountCodeList';
import Services from '@/services';
import { buildFormData } from '@/_axios';

export default {
  name: 'AchievementEdit',
  components: { TextsInput, DiscountCodeList },
  props: ['id'],
  data () {
    return {
      spinners: {
        contentIsLoading: false,
        submitting: false,
      },
      achievement: {
        name: null,
        image: null,
        imagePath: null,
        isActive: false,
        isCharity: false,
        isHighlighted: false,
        goal: 0,
        usedCoupons: 0,
        totalCoupons: 0,
        colorHex: '#A5DFD3',
        texts: {
          lv: {
            title: null,
            subtitle: null,
            description: null,
          },
          en: {
            title: null,
            subtitle: null,
            description: null,
          },
        }
      },
      errors: {},
      textsFields: [
        {
          id: 'title',
          label: this.$dt('achievement_title', 'Virsraksts', 'admin'),
          placeholder: this.$dt('achievement_title_placeholder', 'Ievadi virsrakstu', 'admin'),
          type: 'text',
        },
        {
          id: 'subtitle',
          label: this.$dt('achievement_subtitle', 'Apakšvirsraksts', 'admin'),
          placeholder: this.$dt('achievement_subtitle_placeholder', 'Ievadi Apakšvirsrakstu', 'admin'),
          type: 'text',
        },
        {
          id: 'description',
          label: this.$dt('achievement_description', 'Apraksts', 'admin'),
          placeholder: this.$dt('achievement_description_placeholder', 'Ievadi aprakstu', 'admin'),
          type: 'textarea',
        },
      ]
    }
  },
  computed: {
    textsErrors () {
      return Object.keys(this.errors)
        .filter(key => key.startsWith('texts.'))
        .reduce((obj, key) => {
          // transforms 'texts.lv.title' to 'lv.title'
          obj[key.split('.').splice(1).join('.')] = this.errors[key];
          return obj;
        }, {});
    },
  },
  mounted () {
    if (!this.id) return;

    this.getData()  
  },
  methods: {
    // Reads uploaded image as base64.
    onImageChange (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.achievement.imagePath = reader.result;
      };
    },
    getData() {
      this.spinners.contentIsLoading = true;
      Services.admin.achievementsView(this.id)
        .then(({ data: { data } }) => {
          this.achievement = {
            name: data.name,
            imagePath: data.image ? data.image.path : null,
            isActive: data.is_active,
            isCharity: data.is_charity,
            isHighlighted: data.is_highlighted,
            usedCoupons: data.used_coupons,
            totalCoupons: data.total_coupons,
            goal: data.goal,
            colorHex: data.color_hex,
            texts: {
              lv: {
                title: data.texts.lv.title || null,
                subtitle: data.texts.lv.subtitle || null,
                description: data.texts.lv.description || null,
              },
              en: {
                title: data.texts.en.title || null,
                subtitle: data.texts.en.subtitle || null,
                description: data.texts.en.description || null,
              }
            }
          }
          this.spinners.contentIsLoading = false;
        })
        .catch(error => {
          this.alertError()
        })
        .finally(() => {
          this.spinners.contentIsLoading = false;
        });
    },
    openConfirmModal() {
      this.$refs['modal-confirm'].show();
    },
    closeConfirmModal() {
      this.$refs['modal-confirm'].hide();
    },
    submitConfirmModal() {
      this.spinners.submitting = true;
      Services.admin.achievementsDelete(this.id)
        .then(() => {
          this.$router.back();
          this.alertSuccess();
        })
        .catch(error => {
          this.alertError()
        })
        .finally(() => {
          this.spinners.submitting = false;
        });
    },
    saveAchievement() {
      const data = new FormData();
      buildFormData(data, {
        name: this.achievement.name,
        image: this.achievement.image,
        is_active: this.achievement.isActive,
        is_charity: this.achievement.isCharity,
        is_highlighted: this.achievement.isHighlighted,
        goal: Number(this.achievement.goal),
        color_hex: this.achievement.colorHex,
        texts: {
          lv: {
            title: this.achievement.texts.lv.title,
            subtitle: this.achievement.texts.lv.subtitle,
            description: this.achievement.texts.lv.description,
          },
          en: {
            title: this.achievement.texts.en.title,
            subtitle: this.achievement.texts.en.subtitle,
            description: this.achievement.texts.en.description,
          }
        }
      });
      this.spinners.submitting = true;
      this.errors = {};
      
      if (this.id) {
        Services.admin.achievementsUpdate(this.id, data)
          .then(() => {
            this.alertSuccess();
          })
          .catch(error => {
            this.errors = error.data.data.errors || {};
            this.alertError();
          })
          .finally(() => {
            this.spinners.submitting = false;
          });
      } else {
        Services.admin.achievementsCreate(data)
          .then(() => {
            this.alertSuccess();
            this.$router.push({ name: 'Admin', params: { tab: 'achievements' } });
          })
          .catch(error => {
            this.errors = error.data.data.errors || {};
            this.alertError();
          })
          .finally(() => {
            this.spinners.submitting = false;
          });
      }
    }
  }
}
</script>

<style scoped>
</style>
